import React, { useState } from "react";
import Card from "../../../components/ui/Card";
import { DollarSign, TrendingUp, Users, CreditCard } from "lucide-react";
import PayoutsManager from "../components/finance/PayoutsManager";

const FinancePage = () => {
  const [activeTab, setActiveTab] = useState("overview");

  const stats = [
    { title: "Total Revenue", value: "2,450,000 ETB", icon: DollarSign, color: "text-green-600" },
    { title: "Monthly Growth", value: "+23.5%", icon: TrendingUp, color: "text-blue-600" },
    { title: "Active Subscribers", value: "12,543", icon: Users, color: "text-purple-600" },
    { title: "Pending Payouts", value: "450,000 ETB", icon: CreditCard, color: "text-orange-600" },
  ];

  const recentTransactions = [
    { id: 1, type: "Subscription", user: "Abebe Tesfaye", amount: 250, status: "Completed" },
    { id: 2, type: "Tip", user: "Mekdes Alemu", amount: 500, status: "Completed" },
    { id: 3, type: "Purchase", user: "Dawit Bekele", amount: 1200, status: "Pending" },
    { id: 4, type: "Payout", user: "Creator: Gigi Kiya", amount: -15000, status: "Processing" },
    { id: 5, type: "Subscription", user: "Sara Mulugeta", amount: 350, status: "Completed" },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-800">Finance Dashboard</h1>
        <p className="text-slate-500 mt-1">
          Revenue tracking, payouts, and financial analytics.
        </p>
      </div>

       {/* Tabs */}
       <div className="border-b border-slate-200">
          <div className="flex gap-6">
            <button
              onClick={() => setActiveTab("overview")}
              className={`py-2 text-sm font-medium border-b-2 transition-colors ${
                activeTab === "overview"
                  ? "border-purple-600 text-purple-700"
                  : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
            >
              Overview
            </button>
            <button
              onClick={() => setActiveTab("payouts")}
              className={`py-2 text-sm font-medium border-b-2 transition-colors ${
                activeTab === "payouts"
                  ? "border-purple-600 text-purple-700"
                  : "border-transparent text-slate-500 hover:text-slate-700"
              }`}
            >
              Payout Processing
            </button>
          </div>
       </div>

      {activeTab === "overview" ? (
         <>
            {/* Stats Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {stats.map((stat, idx) => (
                <Card key={idx} className="p-6">
                    <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm text-slate-500">{stat.title}</p>
                        <p className={`text-2xl font-bold ${stat.color} mt-1`}>{stat.value}</p>
                    </div>
                    <div className={`p-3 rounded-full bg-slate-100 ${stat.color}`}>
                        <stat.icon size={24} />
                    </div>
                    </div>
                </Card>
                ))}
            </div>

            {/* Recent Transactions */}
            <Card>
                <h3 className="text-lg font-semibold text-slate-800 mb-4">Recent Transactions</h3>
                <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-slate-50">
                    <tr>
                        <th className="p-3 text-left font-semibold text-slate-600">Type</th>
                        <th className="p-3 text-left font-semibold text-slate-600">User</th>
                        <th className="p-3 text-right font-semibold text-slate-600">Amount</th>
                        <th className="p-3 text-left font-semibold text-slate-600">Status</th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200">
                    {recentTransactions.map((txn) => (
                        <tr key={txn.id}>
                        <td className="p-3">
                            <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">
                            {txn.type}
                            </span>
                        </td>
                        <td className="p-3 text-slate-700">{txn.user}</td>
                        <td className={`p-3 text-right font-semibold ${txn.amount < 0 ? 'text-red-600' : 'text-green-600'}`}>
                            {txn.amount > 0 ? '+' : ''}{txn.amount.toLocaleString()} ETB
                        </td>
                        <td className="p-3">
                            <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                            txn.status === 'Completed' ? 'bg-green-100 text-green-700' :
                            txn.status === 'Pending' ? 'bg-yellow-100 text-yellow-700' :
                            'bg-blue-100 text-blue-700'
                            }`}>
                            {txn.status}
                            </span>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </Card>
         </>
      ) : (
          <PayoutsManager />
      )}
    </div>
  );
};

export default FinancePage;
